/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiSanctionRecordRole
 */
export interface ApiSanctionRecordRole {
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    recordExternalId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    sinceDay?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    sinceMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    sinceYear?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    toDay?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    toMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    toYear?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecordRole
     */
    occupation?: string;
}

/**
 * Check if a given object implements the ApiSanctionRecordRole interface.
 */
export function instanceOfApiSanctionRecordRole(value: object): value is ApiSanctionRecordRole {
    if (!('recordExternalId' in value) || value['recordExternalId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function ApiSanctionRecordRoleFromJSON(json: any): ApiSanctionRecordRole {
    return ApiSanctionRecordRoleFromJSONTyped(json, false);
}

export function ApiSanctionRecordRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionRecordRole {
    if (json == null) {
        return json;
    }
    return {
        
        'recordExternalId': json['recordExternalId'],
        'type': json['type'],
        'title': json['title'],
        'sinceDay': json['sinceDay'] == null ? undefined : json['sinceDay'],
        'sinceMonth': json['sinceMonth'] == null ? undefined : json['sinceMonth'],
        'sinceYear': json['sinceYear'] == null ? undefined : json['sinceYear'],
        'toDay': json['toDay'] == null ? undefined : json['toDay'],
        'toMonth': json['toMonth'] == null ? undefined : json['toMonth'],
        'toYear': json['toYear'] == null ? undefined : json['toYear'],
        'occupation': json['occupation'] == null ? undefined : json['occupation'],
    };
}

export function ApiSanctionRecordRoleToJSON(json: any): ApiSanctionRecordRole {
    return ApiSanctionRecordRoleToJSONTyped(json, false);
}

export function ApiSanctionRecordRoleToJSONTyped(value?: ApiSanctionRecordRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recordExternalId': value['recordExternalId'],
        'type': value['type'],
        'title': value['title'],
        'sinceDay': value['sinceDay'],
        'sinceMonth': value['sinceMonth'],
        'sinceYear': value['sinceYear'],
        'toDay': value['toDay'],
        'toMonth': value['toMonth'],
        'toYear': value['toYear'],
        'occupation': value['occupation'],
    };
}

